export default function getFilenameFromUrl(url: string) {
  const { pathname } = new URL(url);
  const index = pathname.lastIndexOf("/");
  return pathname.substring(index + 1); // if index === -1 then index+1 will be 0
}
